<template>
    <DeletePart></DeletePart>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const DeletePart = defineAsyncComponent(() =>
    import(
        "../../../components/ProjectManagement/HelpPage/PartMaintenance/DeletePart.vue"
    )
);

export default {
    name: "Project_HelpDeletePart", //The name you are in should not equal the name of the component you are importing.
    components: { DeletePart, AuthLayout },
};
</script>
